import { errorMessage } from "@api/errors";
import { notifications } from "@mantine/notifications";

/** The Hungarian message of a failed request as a red toast. Every failed write gets it from the query client
 *  (app/queryClient.ts); a page calls it for a failed download or an on-demand read. ``id``: one toast for many
 *  failures of the same kind. */
export const notifyError = (error: unknown, id?: string) => notifications.show({ id, color: "red", message: errorMessage(error) });
